import { AbstractControl, Validators } from '@angular/forms';
import { MetaService } from '@bo-client/core/api/meta-service';
import { ContactDataForm } from '@bo-client/shared/models/contactDataDto';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

export function initContactDataSalutationSubscription(
  formGroup: ContactDataForm,
  metaService: MetaService,
  destroy$: Observable<void>
): void {
  const salutation = formGroup.controls.salutation;
  let skipInactiveFieldClear = true;

  salutation.valueChanges
    .pipe(
      startWith(salutation.value),
      distinctUntilChanged(),
      switchMap((salutationId: string) =>
        metaService.salutationValues$.pipe(
          map((salutationValues) => isPersonSalutation(salutationId, salutationValues))
        )
      ),
      takeUntil(destroy$)
    )
    .subscribe((isPerson) => {
      const { firstName, lastName, company, companyAddition } = formGroup.controls;

      if (salutation.enabled) {
        if (isPerson) {
          firstName.enable({ emitEvent: false });
          lastName.enable({ emitEvent: false });
        } else {
          company.enable({ emitEvent: false });
          companyAddition.enable({ emitEvent: false });
        }
      }

      applySalutationValidators(firstName, lastName, company, companyAddition, isPerson);

      if (skipInactiveFieldClear) {
        skipInactiveFieldClear = false;
        return;
      }

      if (!hasSalutationValue(salutation.value)) {
        return;
      }

      if (isPerson) {
        company.setValue(null, { emitEvent: false });
        companyAddition.setValue(null, { emitEvent: false });
      } else {
        firstName.setValue(null, { emitEvent: false });
        lastName.setValue(null, { emitEvent: false });
      }
    });
}

function hasSalutationValue(salutationId: string | null | undefined): boolean {
  return salutationId != null && salutationId !== '';
}

function isPersonSalutation(
  salutationId: string,
  salutationValues: { id: string; type?: string }[]
): boolean {
  return salutationValues.find((x) => x.id === salutationId)?.type?.toLowerCase() === 'person';
}

function applySalutationValidators(
  firstName: AbstractControl,
  lastName: AbstractControl,
  company: AbstractControl,
  companyAddition: AbstractControl,
  isPerson: boolean
): void {
  setValidatorsRequired(firstName, isPerson);
  setValidatorsRequired(lastName, isPerson);
  setValidatorsRequired(company, !isPerson);
  setValidatorsRequired(companyAddition, false);
}

function setValidatorsRequired(control: AbstractControl, isValidator: boolean): void {
  if (isValidator) {
    control.setValidators([Validators.required]);
  } else {
    control.clearValidators();
  }
  control.updateValueAndValidity();
}
